import React, {useContext, useEffect, useState} from 'react';
import {AgentContext} from "../context/agent-context.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputPassword from "../../../../../components/input/input-password.jsx";
import projectUtils from "../../../../../utils/project-utils.js";

const ChangePassword = ({open, setOpen}) => {
    const {
        user,
        passwordComplexity,
        passWordFocus,
        setUser,
        setChanges
    } = useContext(AgentContext);

    const [password, setPassword] = useState("")
    const [passwordConfirm, setPasswordConfirm] = useState("")
    const [isValid, setIsValid] = useState(false)

    const save = () => {
        if (passwordConfirm && !isValid) {
            projectUtils.swalErrorMessage("", "A senha não atende aos requisitos de segurança.")
            return
        }

        setUser(prev => ({
            ...prev,
            user: {
                ...user.user,
                password,
                passwordConfirm,
                changePassword: true
            }
        }))
        setChanges('user');
        setOpen(false)
    }

    return (
        <>
            <Modal isCloseClick={false} overflow={true} open={open} setOpen={() => setOpen(false)} centered size="xl" backdrop="static" keyboard={false} title={"Definir senha"} className={"w-3/12"}>

                <Modal.Body className="p-2">
                    <div className="row">
                        <div className="col-12">
                            <InputPassword
                                disabled={!user.user.status}
                                id="password"
                                type="password"
                                value={password}
                                label="Nova senha"
                                onChange={({target: {value}}) => setPassword(value)}
                                target="password"
                                passwordComplexity={passwordComplexity}
                                passWordFocus={passWordFocus}
                                setIsValid={setIsValid}
                            />
                        </div>
                        <div className="col-12">
                            <InputPassword
                                id="passwordConfirm"
                                disabled={!user.user.status}
                                type="password"
                                value={passwordConfirm}
                                label="Confirmação de senha"
                                onChange={({target: {value}}) => setPasswordConfirm(value)}
                                password={password}
                                setIsValid={setIsValid}
                            />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className={"p-2"}>
                    <div className={"w-full flex gap-2 justify-end"}>
                        <Button disabled={!password || !passwordConfirm || password !== passwordConfirm} onClick={save}>Confirmar</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChangePassword;